import { Modal } from "../../ui/components";
import FilesApi from "../../api/files";

export class TranscriberSettings extends Modal {
    init() {
        super.init();
        this.languageSelect = this.transcribeToLanguage?.element;
        this.setupRequestAndListeners();
        this.setupSwitchListeners();


         this.close_btn.on('click', this.reset.bind(this));
    }


    setupRequestAndListeners() {
        if (!this.ButtonTranscribe) return;

        const fileId = window.location.pathname.split("/").pop();
        this.requestData = {
            files: [fileId],
            options: {
                language: this.getLanguageValue(),
                speakers: this.getSpeakersValue(),
            },
            freeRetry: 1,
        };
        this.ButtonTranscribe.on("click", this.handleTranscribeClick.bind(this));
    }

    setupSwitchListeners() {
        if (this.language_switch) {
            this.language_switch.on('change', this.updateButtonState.bind(this));
        }

        if (this.speakers_setting) {
            this.speakers_setting.on('change', this.updateButtonState.bind(this));
        }

        this.updateButtonState();
    }

    updateButtonState() {
        if (!this.ButtonTranscribe) return;

        const isLanguageSwitchActive = this.language_switch?.element.checked || false;
        const isSpeakersSettingActive = this.speakers_setting?.element.checked || false;

        const isAnySwitchActive = isLanguageSwitchActive || isSpeakersSettingActive;

        if (!isAnySwitchActive) {
            this.ButtonTranscribe.element.disabled = true;
            this.ButtonTranscribe.addClass('disabled');
        } else {
            this.ButtonTranscribe.element.disabled = false;
            this.ButtonTranscribe.removeClass('disabled');
        }
    }

    getLanguageValue() {
        if (this.language_switch && !this.language_switch.element.checked) {
            return this.lang
        }
        return this.languageSelect?.value || this.lang;
    }

    getSpeakersValue() {
        return this.speakers_setting?.element.checked ? "auto" : this.speakers;
    }

    async handleTranscribeClick() {
        if (this.ButtonTranscribe.element.disabled) return;

        this.requestData.options.language = this.getLanguageValue();
        this.requestData.options.speakers = this.getSpeakersValue();

        console.log(this.requestData);
        try {
            await FilesApi.transcribe(this.requestData);
        } catch (error) {
            console.error("Ошибка транскрибации:", error);
        }
        this.reset();
    }

    reset() {
        if (this.speakers_setting && this.language_switch) {
            this.speakers_setting.element.checked = false;
            this.language_switch.element.checked = false;
        }

        this.language_setting?.removeClass("show");

        this.updateButtonState();
    }

    open(selectedData = {}, speak = false) {
        const { languageCode } = selectedData;

        if(speak && this.speakers_setting){
            this.all_settings?.hide();
            this.language_settings?.hide();
            this.speakers_settings?.show();
            this.speakers_setting.element.checked = true;
        }

        if (this.language_switch?.element.checked) {
            this.all_settings?.hide();
            this.language_settings?.show();
            this.speakers_settings?.hide();
            this.language_setting.addClass("show");
        }

        if (this.languageSelect && languageCode && this.language_switch) {
            this.all_settings?.show();
            this.language_settings?.hide();
            this.speakers_settings?.hide();
            this.languageSelect.value = languageCode;
            this.language_switch.element.checked = true;
            this.language_setting.addClass("show");
        }

        this.updateButtonState();

        this.show();
    }
}
